<template>
    <b-card>
        <div class="card-text d-flex flex-wrap">
            <div class="w-100">
                <app-form-select
                    label="Sede"
                    :options="venues"
                    v-model="management.venueId"
                    :has-error="$v.management.venueId.$error"
                    error-message="Debe seleccionar la sede del reporte"
                    @change="$v.management.venueId.$touch()"
                    value-field="id"
                    text-field="name"
                ></app-form-select>
            </div>
            <div class="w-100">
                <app-date-time-picker
                    :withTime="false"
                    label="Fecha de la gestión"
                    v-model="management.managementDate"
                    :required="true"
                    error-message="Debe especificar la fecha de la gestión"
                    :has-error="$v.management.managementDate.$error"
                    :max-date="moment().toDate()"
                />
            </div>
            <div class="w-100">
                <app-form-select-input
                    label="Tipo"
                    :options="types"
                    :required="true"
                    error-message="Debe seleccionar el tipo de gestión que se quiere grabar"
                    :has-error="$v.management.internalManagementTypeId.$error"
                    @change="$v.management.internalManagementTypeId.$touch()"
                    v-model="management.internalManagementTypeId"
                />
            </div>
            <div class="w-100">
                <app-form-text-input
                    label="Titulo"
                    v-model="management.name"
                    :required="true"
                    :has-error="$v.management.name.$error"
                    @input="$v.management.name.$touch()"
                    error-message="Debe diligenaciar el titulo de la gestión que desea grabar"
                />
            </div>
            <div class="w-100">
                <label for="description">Descripción</label>
                <wysiwyg
                    id="description"
                    v-model="management.description"
                    @change="$v.management.description.$touch()"
                />
                <span
                    v-if="$v.management.description.$error"
                    class="field-error"
                >
                    Debe diligenciar la descripción de la gestión que desea
                    grabar
                </span>
            </div>
            <div class="w-100">
                <b-row>
                    <b-col cols="12" md="6" lg="3">
                        <br />
                        <b-btn
                            v-b-toggle.collapse1
                            variant="primary"
                            class="btn-block"
                            block
                            size="sm"
                        >
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            Agregar archivos
                        </b-btn>
                    </b-col>
                    <b-form-file
                        v-model="files"
                        multiple
                        placeholder="seleccione un archivo"
                        drop-placeholder="suelte el archivo aquí..."
                    ></b-form-file>
                </b-row>
                <b-collapse id="collapse1" class="mt-2">
                    <b-row>
                        <b-col cols="12" lg="3"></b-col>
                        <b-col cols="12" md="12" lg="12">
                            <b-card>
                                <div class="card-text">
                                    <app-upload-or-take-photo
                                        id="internal-management-photos"
                                        title="Fotos de gestión"
                                        v-model="files"
                                    />
                                    <div
                                        v-if="files.files && files.files.length"
                                    >
                                        <button
                                            class="btn btn-sm btn-danger pull-right"
                                            @click="cancelFilesSelected"
                                        >
                                            <i
                                                class="fa fa-trash-o"
                                                aria-hidden="true"
                                            ></i>
                                            Cancelar archivos seleccionados
                                        </button>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                        <b-col cols="12" lg="3"></b-col>
                    </b-row>
                </b-collapse>
            </div>
        </div>
    </b-card>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import internalManagementRepository from '../../../../../repositories/internalManagement.repository'
import UploadOrTakePhoto from '../../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import venuesRepository from '@repositories/venues.repository'
export default {
    components: {
        appUploadOrTakePhoto: UploadOrTakePhoto,
    },
    props: {
        selectedClient: {
            type: Object,
            required: true,
        },
        selectedManagement: {
            type: Object,
            default: null,
        },
        onSave: {
            type: Function,
        },
        types: {
            type: Array,
            default: () => [],
        },
        venues: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            management: {
                id: '',
                internalManagementTypeId: '',
                managementDate: '',
                name: '',
                description: '',
                venueId: '',
            },
            files: '',
        }
    },
    watch: {
        selectedManagement(val) {
            if (!val) {
                this.reset()
            } else {
                Object.keys(this.management).map(
                    key =>
                        key !== 'managementDate' &&
                        (this.management[key] = val[key.toUnderscore()])
                )
                if (val['management_date']['date']) {
                    this.management.managementDate = moment(
                        val['management_date']['date']
                    ).format('DD/MM/YYYY')
                } else {
                    this.management.managementDate = moment(
                        val['management_date']
                    ).format('DD/MM/YYYY')
                }
            }
        },
        types(val) {
            if (val.length === 1) {
                this.management.internalManagementTypeId = this.types[0].id
            }
        },
    },
    validations: {
        management: {
            internalManagementTypeId: { required },
            name: { required },
            managementDate: { required },
            description: { required },
            venueId: { required },
        },
    },
    methods: {
        async loadVenues(client) {
            const { data } = await repo.get('venues', {
                client,
            })
            this.venues = data
        },
        reset() {
            Object.keys(this.management).map(key => (this.management[key] = ''))
        },
        save() {
            if (this.management.description === '') {
                toastr.info(
                    'Debe diligenciar la descripción de la gestión que desea grabar'
                )
            }
            this.$v.$touch()
            if (this.$v.$invalid) {
                return false
            }

            const formData = new FormData()

            formData.append('clientId', this.selectedClient.id)
            formData.append('userId', this.user.id)
            formData.append('id', this.management.id)
            formData.append(
                'internalManagementTypeId',
                this.management.internalManagementTypeId
            )
            formData.append('managementDate', this.management.managementDate)
            formData.append('name', this.management.name)
            formData.append('description', this.management.description)
            formData.append('venueId', this.management.venueId)

            if (this.files.photos) {
                this.files.photos.map(item => formData.append('photos[]', item))
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append('files[]', item)
                )
            }

            const imr = { ...internalManagementRepository }

            imr.saveInternalManagement(formData)
                .then(data => {
                    this.reset()
                    this.$v.$reset()
                    toastr.success('Gestión interna guardada correctamente')
                    typeof this.onSave === 'function' && this.onSave(data)
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al guardar la gestión')
                })
        },
        cancelFilesSelected() {
            this.$bus.$emit('internal-management-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        cleanFields() {
            this.files = ''
            Object.keys(this.management).map(key => (this.management[key] = ''))
            this.$bus.$emit('internal-management-photos.clean')
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },
    mounted() {
        // this.loadVenues()
    },
    created() {
        this.$bus.$on('internal-management-form.save', this.save)
        this.$bus.$on('internal-management-form.clean', this.cleanFields)
    },
    beforeDestroy() {
        this.$bus.$off('internal-management-form.save')
    },
}
</script>
